<template>
  <div class="u-wrap">
    <div class="card">
      <van-form>
        <van-cell required title="内容" value="" :border="false" />
        <textarea placeholder="请输入内容..." maxlength="300" class="xxnr" v-model="model.fbnr"></textarea>
      </van-form>
      <van-cell title="上传图片" value="" :border="false" />
      <u-upload v-model="model.tp" style="margin-left:12px"></u-upload>
       
    </div>
  
    <div class="b-btn">
      <button class="b-button" :disabled="disable" @click="onSumbit">发布</button>
    </div>
   
  </div>
</template>

<script>
import { getAction, postAction } from '@/api/manage'
import UUpload from '@/components/page/u-upload.vue'
import Vue from 'vue'
import {WX_USER } from "@/store/mutation-types"
export default {
  components:{
    UUpload
  },
  data() {
    return {
     model:{
      sysOrgCode:'',
      fbnr:'',
      tp:'',
     }
    }
  },
  created() {
    let userInfo = Vue.ls.get(WX_USER, {});
    this.model.sysOrgCode = userInfo.sysOrgCode;
  },
  mounted() {
  },
  computed: {
    disable() {
      let disable = true
      if (this.model.fbnr) {
        disable = false
      }

      return disable
    }
  },
  watch:{
  },
  methods: {
    onSumbit(){
       
        postAction('/zhshj/djylwxws/add', this.model).then(res => {
          if (res.success) {
            this.$router.go(-1);
          }
        })
    }
  }
}
</script>

<style lang="less" scoped>
.u-wrap {
  min-height: 100vh;
  box-sizing: border-box;
  background-color: #f5f5f5;
  padding-top: 12px;
}
.card {
  background: #ffffff;
  padding: 0px 0px 16px;
  margin: 0 8px;
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.04);
  border-radius: 5px;
  overflow: hidden;
  height: auto;
  margin-bottom: 12px;
}

.xxnr {
  width: 90%;
  margin: 0 12px;
  height: 128px;
  border-radius: 5px;
  border: 1px solid #ededed;
  padding: 8px;
  font-size: 14px;
}

.b-btn {
  padding: 0 20px;
  margin-bottom: 20px;

  .b-button {
    width: 100%;
    height: 44px;
    background: #3f8ffb;
    border-radius: 5px;
    opacity: 1;
    border: none;
    margin-top: 20px;
    color: #ffffff;
  }

  .b-button[disabled] {
    opacity: 0.48;
  }
}

</style>
